import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import FeatureBlock, { FeatureBlockProps } from './FeatureBlock';

export interface FeatureBlockListProps {
  featureBlocks: FeatureBlockProps[];
}

const FeatureBlockList = ({ featureBlocks }: FeatureBlockListProps): JSX.Element => (
  <Grid padding={['spacing-none', 'spacing-4xl']}>
    <Stack
      direction='column'
      gap='spacing-none'
      justify='center'
      align='flex-start'
    >
      {featureBlocks.map((featureBlock, index) => (
        <Stack
          key={index}
          padding={[index === 0 ? 'spacing-4xl' : 'spacing-xl', 'spacing-none']}
        >
          <FeatureBlock {...featureBlock} />
        </Stack>
      ))}
    </Stack>
  </Grid>
);

export default FeatureBlockList;
